"use client";

import Flex from "@/shared/components/common/Flex";
import Grid from "@/shared/components/common/Grid";
import List from "@/shared/components/common/List";
import TabItem from "./components/TabItem";
type ServiceTab = {
  title: string;
  icon: string;
  link: string;
  id: string;
};
interface TabProps {
  serviceTabs: ServiceTab[];
}
export default function Tab({
  serviceTabs
}: TabProps) {
  return <Flex className="w-full max-md:rounded-lg h-16 md:bg-background border-[1px] border-b-ghost md:rounded-tl-xs max-md:px-3 max-md:h-[70px] md:rounded-tr-xs" id="searchTab" data-sentry-element="Flex" data-sentry-component="Tab" data-sentry-source-file="index.tsx">
      <Grid className="w-full max-sm:gap-0 mx-auto grid-cols-3 md:grid-cols-11 gap-0 place-items-center h-full" data-sentry-element="Grid" data-sentry-source-file="index.tsx">
        <List items={serviceTabs} renderItems={items => <TabItem key={items.link} {...items} />} data-sentry-element="List" data-sentry-source-file="index.tsx" />
      </Grid>
    </Flex>;
}